<template>
  <div class="ui right aligned container">
      <div class="ui grid">
        <div class="ui three wide column">
          <button class="ui button" @click="travel">计算</button>
          <button class="ui button" @click="modal=true">高级</button>
        </div>
        <div class="ui seven wide column" v-if="data.count">
          喵币：{{data.coins}} <span class="ui label"></span>  经验值：{{data.exp}} <span class="ui label"></span> 有效数量：{{data.count}}
        </div>
        <div class="ui six wide column">
          <div class="ui icon input">
            <input type="text" v-model="q" placeholder="搜索">
            <i v-if="q" class="circular close link icon" @click="q=''"></i>
            <i v-else class="inverted circular search link icon"></i>
          </div>
        </div>
      </div>

    <vuetable ref="vuetable"
              api-url="/mm/users"
              :search="q"
              :fields="fields"
              :initialPage="page"
              :perPage="20"
              :route="true"
              @vuetable:route-change="onRouteChange"
              @vuetable:pagination-data="onPaginationData"
    >
    </vuetable>
    <div class="ui grid">
      <div class="ui left aligned six wide column">
        <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>
      </div>
      <div class="right floated six wide column">
        <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
      </div>
    </div>

    <Modal v-model="modal" title="梭哈">
      <div>
        <button class="negative ui button" @click="giveAll">投币所有</button>
        <button class="negative ui button" @click="exchangeAll">兑换所有</button>
        <button class="negative ui button" @click="exchangeAndGiveAll">兑换并投币所有</button>
      </div>
    </Modal>

  </div>
</template>

<script>
import axios from 'axios'
import Vuetable from '@/table/Vuetable'
import VuetablePagination from '@/table/VuetablePagination'
import VuetablePaginationInfo from '@/table/VuetablePaginationInfo'
import Modal from '@/components/Modal'

export default {
  name: 'UserList',
  components: {
    Modal,
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
  },
  data () {
    return {
      data: {

      },
      modal: false,
      fields: [
        //{ name: 'id', title: 'ID', callback: 'link' },
        { name: 'name', title: '昵称', callback: 'link', sortField: 'name' },
        { name: 'avatar', title: '头像', callback: 'avatar' },
        { name: 'coins', title: '金币', sortField: 'coins' },
        { name: 'exp', title: '经验', sortField: 'exp' },
        { name: 'delegated', title: '托管', sortField: 'delegated' },
        { name: 'starid', title: '明星', callback: 'star' },
      ],
      q: '',
      page: +this.$route.query.page || 1,
    }
  },
  watch: {
    '$route' (to) {
      this.page = +to.query.page
      this.q = to.query.q || ''
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    onRouteChange (data) {
      let query = { page: data.page + 1 }
      if (this.q) {
        query.q = this.q
      }
      this.$router.push({ path: '/mm/users', query: query })
    },
    avatar (val, item) {
      return '<a href="/#/mm/users/' + item.id + '"><img class="ui tiny image" src="' + val + '"></a>'
    },
    link (val, item) {
      return '<a href="/#/mm/users/' + item.id + '">' + val + '</a>'
    },
    star (val) {
      return '<a href="/#/mm/stars/' + val + '">' + val + '</a>'
    },
    load() {
      axios.get('/mm/stats').then(({data}) => {
        this.data = data.data
      }, (err) => {
        this.$toasted.error(err.message)
      })
    },
    travel() {
      axios.post('/mm/travel').then(({data}) => {
        this.data = data.data
      }, (err) => {
        this.$toasted.error(err.message)
      })
    },
    giveAll() {
      axios.post('/mm/giveAll').then(({data}) => {
        console.log(data.data)
      }, (err) => {
        this.$toasted.error(err.message)
      })
    },
    exchangeAll() {
      axios.post('/mm/exchangeAll').then(({data}) => {
        console.log(data.data)
      }, (err) => {
        this.$toasted.error(err.message)
      })
    },
    exchangeAndGiveAll() {
      axios.post('/mm/exchangeAndGiveAll').then(({data}) => {
        console.log(data.data)
      }, (err) => {
        this.$toasted.error(err.message)
      })
    },
  }
}
</script>

<style scoped>

</style>
